import React from "react"
import type { FeatureFlagKey } from "@/schema"
import {
  Binoculars,
  Building2,
  ClipboardList,
  Contact,
  CreditCard,
  FileBarChart,
  FolderOpen,
  HandCoins,
  ListOrdered,
  ShieldUser,
  SquareCheck,
  UsersRound,
  Video,
  Workflow,
} from "lucide-react"

export interface SidebarSubRoute {
  href: string
  label: string
  featureFlag?: "internal" | "beta" | FeatureFlagKey
  supportsAllBooks?: boolean
}

export interface SidebarRoute {
  href: string
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
  label: string
  exact?: boolean
  featureFlag?: "internal" | "beta" | FeatureFlagKey
  badge?: string
  subRoutes?: SidebarSubRoute[]
  supportsAllBooks?: boolean
}

interface SidebarGroup {
  groupLabel: string
  routes: SidebarRoute[]
}

export const sidebarGroups: SidebarGroup[] = [
  {
    groupLabel: "Activity",
    routes: [
      {
        href: "/tasks",
        icon: SquareCheck,
        label: "Tasks",
        exact: true,
        supportsAllBooks: true,
      },
      {
        href: "/meetings",
        icon: Video,
        label: "Meetings",
        supportsAllBooks: true,
      },
      {
        href: "/projects",
        icon: FolderOpen,
        label: "Projects",
        supportsAllBooks: true,
      },
      {
        href: "/opportunities",
        icon: HandCoins,
        label: "Opportunities",
        exact: true,
        supportsAllBooks: true,
      },
    ],
  },
  {
    groupLabel: "Records",
    routes: [
      {
        href: "/clients",
        icon: ShieldUser,
        label: "Clients",
        supportsAllBooks: true,
        subRoutes: [
          { href: "/clients", label: "Households", supportsAllBooks: true },
          { href: "/clients/people", label: "People", supportsAllBooks: true },
          { href: "/clients/reviews", label: "Reviews", supportsAllBooks: true },
          { href: "/past-clients", label: "Past clients", supportsAllBooks: true },
        ],
      },
      {
        href: "/prospects",
        icon: UsersRound,
        label: "Prospects",
        supportsAllBooks: true,
      },
      {
        href: "/contacts",
        icon: Contact,
        label: "Other contacts",
        supportsAllBooks: true,
      },
      {
        href: "/businesses",
        icon: Building2,
        label: "Businesses",
        supportsAllBooks: true,
      },
      {
        href: "/custodian-accounts",
        icon: CreditCard,
        label: "Accounts",
        subRoutes: [
          { href: "/custodian-accounts", label: "Custodian" },
          { href: "/manual-accounts", label: "Manual" },
          { href: "/insurance-policies", label: "Insurance" },
          { href: "/trusts", label: "Trusts", supportsAllBooks: true },
        ],
      },
    ],
  },
  {
    groupLabel: "Platform",
    routes: [
      {
        href: "/sequences",
        icon: ListOrdered,
        label: "Sequences",
      },
      {
        href: "/scouting",
        icon: Binoculars,
        label: "Scouting",
      },
      {
        href: "/automations",
        icon: Workflow,
        label: "Automations",
        supportsAllBooks: true,
      },
      {
        href: "/reports",
        icon: FileBarChart,
        label: "Reports",
        supportsAllBooks: true,
      },
      {
        href: "/intake-forms",
        icon: ClipboardList,
        label: "Intake forms",
      },
    ],
  },
]
